import { Navigate, Outlet, useLocation } from 'react-router';
import React from 'react';

interface Props {
  rootPath: string;
  fallbackPath: string;
}

export const BaseOutlet: React.FC<Props> = ({ rootPath, fallbackPath }) => {
  const location = useLocation();
  if (location.pathname === rootPath || location.pathname === '') {
    return <Navigate to={fallbackPath} replace />;
  }
  return <Outlet />;
};
